module.exports = __webpack_public_path__ + "dingbeauty/admin/img/lineFriend_2.406274ae.jpg";